import React, { useEffect, useState } from 'react';
import { Modal }  from '@/components/ui/modal';
import { Button } from '@/components/ui/button';

interface Props {
  open: boolean;
  secondsRemaining: number;
  onExtend: () => void;
  onLogout: () => void;
}

function formatRemaining(secs: number): string {
  if (secs >= 60) {
    const m = Math.floor(secs / 60);
    const s = secs % 60;
    return s > 0 ? `${m}m ${s}s` : `${m}m`;
  }
  return `${secs}s`;
}

export const SessionTimeoutModal: React.FC<Props> = ({ open, secondsRemaining, onExtend, onLogout }) => {
  const [secs, setSecs] = useState(secondsRemaining);

  useEffect(() => {
    setSecs(secondsRemaining);
    if (!open) return;
    const t = setInterval(() => setSecs((s) => Math.max(s - 1, 0)), 1000);
    return () => clearInterval(t);
  }, [open, secondsRemaining]);

  return (
    <Modal
      open={open}
      onClose={onExtend}
      title="Session expiring soon"
      footer={
        <>
          <Button variant="secondary" onClick={onLogout}>Sign out</Button>
          <Button onClick={onExtend}>Stay signed in</Button>
        </>
      }
    >
      <p className="text-sm text-neutral-600">
        Your session will expire in{' '}
        <span className="font-semibold text-neutral-900">{formatRemaining(secs)}</span>.
        Stay signed in to continue working.
      </p>
    </Modal>
  );
};
